import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ChatsService {

  public myMessage;
  public buildingId;
  public userAdmin;
  public lastServerResponse = new BehaviorSubject<any>(null);

  constructor(private http: HttpClient) {}

  public getOptions(params?: any): any {
    if (params) {
      const options = new HttpParams({
        fromObject: params,
      });

      return { params: options };
    }
    return undefined;
  }

  public getLinks() {
    return this.http.get(`/api/lk/v1/info/links`);
  }

  public getChatsList(params: {scId: number | string; buildingIds: any}): Observable<any> {

    if (this.buildingId) {
      // ÐÐ¾Ð»ÑÑÐ¸ÑÑ Ð²ÑÐµ ÑÐ°ÑÑ Ð² Ð·Ð´Ð°Ð½Ð¸Ð¸
      return this.http.get(`/api/chats/v1/admin/building/${this.buildingId}/chats`);
    } else {
      // ÐÐ¾Ð»ÑÑÐ¸ÑÑ ÑÐ¿Ð¸ÑÐ¾Ðº ÑÐ°ÑÐ¾Ð² c Ð£Ð Ð² Ð·Ð´Ð°Ð½Ð¸ÑÑ
      if (this.userAdmin) {
        // Ð ÐÐ Ð ÐÐ´Ð¼Ð¸Ð½Ð°
        return this.http.get('/api/chats/v1/admin/buildings/sc/chat', this.getOptions(params));
      } else {
        // Ð ÐÐ Ð Ð£Ð
        return this.http.get('/api/chats/v1/sc/buildings/sc/chat', this.getOptions(params));
      }
    }
  }

  public getChatMessages(params: any): Observable<any> {
    // ÐÐ¾Ð»ÑÑÐ¸ÑÑ Ð²ÑÐµ ÑÐ¾Ð¾Ð±ÑÐµÐ½Ð¸Ñ (Ð¸Ð»Ð¸ Ð¸Ð·Ð±ÑÐ°Ð½Ð½Ð¾) Ð¾Ð¿ÑÐµÐ´ÐµÐ»ÐµÐ½Ð½Ð¾Ð³Ð¾ ÑÐ°ÑÐ°
    if (this.userAdmin) {
      // delete params.filter.scId
      return this.http.get(`/api/chats/v1/admin/chat/${params.chatId}/messages`, this.getOptions(params.filter));
    } else {
      return this.http.get(`/api/chats/v1/sc/${params.chatId}/messages`, this.getOptions(params.filter));
    }
  }

  public getComplaintsInChat(params: any): Observable<any>  {
    if (this.userAdmin) {
      return this.http.post(`/api/complaint/v1/admin/member/chat/${params.chatId}`, {});
    } else {
      return this.http.post(`/api/complaint/v1/admin/member/chat/${params.chatId}`, {});
    }
  }

  public sendMessage(params: any, body: any): Observable<any> {
    if (this.userAdmin) {
      return this.http.post(`/api/chats/v1/admin/chat/${params.chatId}/message`, body);
    } else {
      return this.http.post(`/api/chats/v1/sc/${params.chatId}/message?scId=${params.scId}`, body);
    }
  }

  public deleteMessage(params: {chatId: number; timeId: number; scId: number;}): Observable<any> {
    if (this.userAdmin) {
      return this.http.delete(`/api/chats/v1/admin/chat/${params.chatId}/message/${params.timeId}`);
    } else {
      return this.http.delete(`/api/chats/v1/sc/${params.chatId}/message/${params.timeId}?scId=${params.scId}`);
    }
  }

  public editMessage(params: {chatId: number; timeId: number; scId: number;}, body: any): Observable<any> {
    if (this.userAdmin) {
      return this.http.put(`/api/chats/v1/admin/chat/${params.chatId}/message/${params.timeId}`, body);
    } else {
      return this.http.put(`/api/chats/v1/sc/${params.chatId}/message/${params.timeId}?scId=${params.scId}`, body);
    }
  }

  public getParticipants(params: {chatId: number; filter: {search: string;}}): Observable<any> {
    if (this.userAdmin) {
      return this.http.get(`/api/chats/v1/admin/chat/${params.chatId}/participants/search`, this.getOptions(params.filter));
    } else {
      return this.http.get(`/api/chats/v1/sc/chat/${params.chatId}/participants/search`, this.getOptions(params.filter));
    }
  }

  public getParticipantsList(params: {chatId: number;}): Observable<any> {
    if (this.userAdmin) {
      return this.http.get(`/api/chats/v1/admin/chat/${params.chatId}/participants`, this.getOptions({limit: 30}));
    } else {
      return this.http.get(`/api/chats/v1/sc/chat/${params.chatId}/participants`, this.getOptions({limit: 30}));
    }
  }

  public getPolls(params: {scId: number; chatId: number; filter: any}): Observable<any> {
    if (this.userAdmin) {
      return this.http.get(`/api/chats/v1/admin/chat/${params.chatId}/messages/polls`, this.getOptions(params.filter));
    } else {
      return this.http.get(`/api/chats/v1/sc/${params.chatId}/messages/polls?scId=-${params.scId}`, this.getOptions(params.filter));
    }
  }

  // Ð¡ÐµÑÐ²Ð¸ÑÐ¾Ð² Ð½Ð¸Ð¶Ðµ Ð½Ðµ Ð±ÑÐ»Ð¾

  public toVote(params: { scId: number; chatId: number, answerId: number; }, body: any): Observable<any> {
    if (this.userAdmin) {
      return this.http.post(`/api/chats/v1/admin/chat/${params.chatId}/answer/${params.answerId}/vote`, body);
    } else {
      return this.http.post(`/api/chats/v1/sc/${params.chatId}/answer/${params.answerId}/vote?scId=${params.scId}`, body);
    }
  }

  public deleteVote(params: { scId: number; chatId: number, pollId: number; }): Observable<any> {
    if (this.userAdmin) {
      return this.http.delete(`/api/chats/v1/admin/chat/${params.chatId}/poll/${params.pollId}/vote`);
    } else {
      return this.http.delete(`/api/chats/v1/sc/${params.chatId}/poll/${params.pollId}/vote?scId=${params.scId}`);
    }
  }

  public getMentionList(params: {chatId: number; filter: {scId: number}}): Observable<any> {
    if (this.userAdmin) {
      return this.http.get(`/api/chats/v1/admin/chat/${params.chatId}/mentioning`, this.getOptions(params.filter));
    } else {
      return this.http.get(`/api/chats/v1/sc/${params.chatId}/mentioning`, this.getOptions(params.filter));
    }
  }

  public readMessage(params: {chatId: number; timeId: number; scId: number;}, body: any): Observable<any> {
    if (this.userAdmin) {
      return this.http.put(`/api/chats/v1/admin/chat/${params.chatId}/message/${params.timeId}/read`, body);
    } else {
      return this.http.put(`/api/chats/v1/sc/${params.chatId}/message/${params.timeId}/read?scId=${params.scId}`, body);
    }
  }
}
